<template>
  <VendorPublisherListView provider-type="vendor" />
</template>

<script>
import VendorPublisherListView from '@/reusable/vendor-publisher-list-view/VendorPublisherListView'

export default {
  components: {
    VendorPublisherListView
  }
}
</script>
